import { createSelector } from 'reselect';

import { IOneLinksState, OneLinkStatusEnum } from '../../types/oneLink';
import { IAppState } from '../reducers';

export const selectRootState = (state: IAppState) => state.oneLink;

export const selectOneLinks = createSelector(selectRootState, (oneLink: IOneLinksState) => oneLink.items);

export const selectOneLinkById = (uid: string, status: OneLinkStatusEnum) =>
  createSelector(selectRootState, (oneLinks) => (oneLinks && oneLinks[status] ? oneLinks[status]?.[uid] : null));

export const selectIsOneLinksFetching = createSelector(selectRootState, (oneLink) => oneLink.isLoading);

export const selectIsSingleOneLinkFetching = createSelector(selectRootState, (oneLink) => oneLink.isLoadingSingle);

export const selectIsOneLinkEditing = createSelector(selectRootState, (oneLink) => oneLink.isEditing);

export const selectIsFinalOneLink = createSelector(selectRootState, (oneLink) => oneLink.isFinal);

export const selectOneLinkRecipients = createSelector(selectRootState, (oneLink) => oneLink.recipients);

export const selectOneLinkTotalCount = createSelector(selectRootState, (oneLink) => {
  return oneLink ? oneLink.totalCount : 0;
});
